module.exports = __webpack_public_path__ + "static/img/003.ddd87362.png";